<div *ngIf="isDataLoaded == true || isFullScreen">
    <div class="ltms-description" *ngIf="!isEngagementPro">{{ mainDiscription }}</div>
    
        <div class="header-section">
            <div class="controls" *ngIf="isEngagementPro">
                <label class="checkbox-cursor" [ngClass]="{'active': showRecordsJourney}">
                    <img *ngIf="showRecordsJourney" src="assets/images/blue-tick.svg" alt="Blue Tick" class="blue-tick"/>
                    <input name="option1" class="checkbox-cursor" type="checkbox" value="Option 1" [(ngModel)]="showRecordsJourney"
                        type="checkbox" [checked]="showRecordsJourney"
                        (change)="onCheckBoxChange.emit('recordsJourney')">
                    Records Journey
                </label>
                <label class="checkbox-cursor" [ngClass]="{'active': showResponseDistribution}">
                    <img *ngIf="showResponseDistribution" src="assets/images/blue-tick.svg" alt="Blue Tick" class="blue-tick"/>
                    <input type="checkbox" class="checkbox-cursor" name="option1" value="Option 1" [(ngModel)]="showResponseDistribution"
                        [checked]="showResponseDistribution" (change)="onCheckBoxChange.emit('responseDistribution')">
                    Response Distribution
                </label>
                <label class="checkbox-cursor" [ngClass]="{'active': showChannelPerformance}">
                    <img *ngIf="showChannelPerformance" src="assets/images/blue-tick.svg" alt="Blue Tick" class="blue-tick"/>
                    <input type="checkbox" class="checkbox-cursor" name="option1" value="Option 1" [(ngModel)]="showChannelPerformance"
                        [checked]="showChannelPerformance" (change)="onCheckBoxChange.emit('channelPerformance')">
                    Channel Performance
                </label>
            </div>
            <div class="controls" *ngIf="isEngagementPro && isAccount">
                <div class="scale-rater-text">Scale selector</div>
                <app-score-dropdown-menu [config]="{width: '120px'}" [selectedOption]="selectedRaterTypeValue?.name" [options]="scaleRaterTypeValue?.options" (selectedOptionChange)="onOptionChange($event)"></app-score-dropdown-menu>
            </div>
        </div>
    <ng-container *ngIf="isDataAvailable && !restrictToday; ">
        <app-engagement-cards [values]="recordsJourneyData" [isDeviationEnabled]="isDeviationEnabled"></app-engagement-cards>
        <div class="group">
            <div *ngIf="isEngagementPro" class="drilldown-table-container">
                <app-engagement-records-summary-drilldown [overallData]="recordsJourneyData" [displayName]="displayName" [selectedOption]="scaleRaterTypeValue?.selectedOption" [isDeviationEnabled]="isDeviationEnabled" (onDrilldownChange)="onDrilldownChange($event)" style="width: 100%;"></app-engagement-records-summary-drilldown>
            </div>
            <div class="graphs" [ngClass]="{'vertical-align': isEngagementPro }">
                <div class="bar-view">
                    <div [ngClass]="{'overlay': fullScreenComponent === 'bar-view'}">
                        <div [ngClass]="{'content': fullScreenComponent === 'bar-view'}">
                            <ng-container>
                                <div class="cardHeading">
                                    <div>
                                        <div class="cardName lato-bold-dark">
                                            Request Trend • {{ trendDisplayName || displayName }}
                                        </div>
                                        <div class="cardDetails lato-regular-light">{{ barGraphDetails }}</div>
                                    </div>
                                    <div class="cardFilter">
                                        <app-ltms-widget-tools [config]='widgetConfigBarGraph'
                                            (onFullscreenClick)="onFullScreen($event,'bar-view')"
                                            [elementId]="widgetConfigBarGraph.elementId"
                                            (onTrendTypeChange)="onTrendTypeChange($event)">
                                        </app-ltms-widget-tools>
                                    </div>
                                </div>

                                <!-- Check if xValues and yValues are empty -->
                                <ng-container
                                    *ngIf="isBarChartLoaded && (barChartConfig.chart.xValues.length === 0 || barChartConfig.chart.yValues.length === 0); else chartTemplate"
                                    style="min-height: 520px;">
                                    <div class="no-data-message">No data available for the current date range. Try changing the date range.</div>
                                </ng-container>

                                <ng-template #chartTemplate>
                                    <div class="bar-chart-container">
                                        <app-ltms-bar-chart-view [config]="barChartConfig" (onSelect)="setDateRange($event)" [componentId]="barChartId"
                                        *ngIf="isBarChartLoaded;else barChartLoader"></app-ltms-bar-chart-view>
                                    </div>
                                    <ng-template #barChartLoader>
                                        <app-ltms-loader class="data-details-loader"></app-ltms-loader>
                                    </ng-template>
                                </ng-template>
                            </ng-container>
                            <!-- can be use to ignore hover over the chart bottom 130px -->
                            <div class="ignore-hover"></div>
                        </div>
                    </div>
                </div>
                <div class="chart-view">
                    <div [ngClass]="{'overlay': fullScreenComponent === 'chart-view'}">
                        <div [ngClass]="{'content': fullScreenComponent === 'chart-view'}" style="height: 350px;">
                            <ng-container style="max-height: 500px;">
                                <!-- Card Header Section -->
                                <div class="cardHeading">
                                    <div>
                                        <div class="cardName lato-bold-dark">
                                            Response Rate Trend • {{ trendDisplayName || displayName }}
                                        </div>
                                        <div class="cardDetails lato-regular-light">{{ lineGraphDetails }}</div>
                                    </div>
                                    <div class="cardFilter">
                                        <app-ltms-widget-tools [config]='widgetConfigLineGraph'
                                            (onFullscreenClick)="onFullScreen($event,'chart-view')"
                                            [elementId]="widgetConfigLineGraph.elementId"
                                            (onTrendTypeChange)="onLineTrendTypeChange($event)">
                                        </app-ltms-widget-tools>
                                    </div>
                                </div>
                                <!-- Check if xValues or yValues are empty -->
                                <ng-container
                                    *ngIf="isLineChartLoaded && !chartData.response_rates.length; else lineChartTemplate">
                                    <div class="no-data-message">No data available for the current date range. Try changing the date range.</div>
                                </ng-container>

                                <ng-template #lineChartTemplate>
                                    <div class="line-chart" *ngIf="isLineChartLoaded;else lineChartLoader">
                                        <app-score-line-chart [chartPlugins]="lineChartPlugins" [elementId]="'engagement-line-chart'"
                                            [chartData]="lineChartdata"></app-score-line-chart>
                                    </div>
                                    <ng-template #lineChartLoader>
                                        <app-ltms-loader class="data-details-loader"></app-ltms-loader>
                                    </ng-template>
                                </ng-template>
                            </ng-container>
                            <div class="ignore-hover"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <div *ngIf="restrictToday" class="no-data-message error-text">
        No data available for the current date range. Try changing the date range.
    </div>
</div>
<div *ngIf="isDataLoaded == false && !isFullScreen" style="height: 30vh;">
    <app-ltms-loader></app-ltms-loader>
</div>
<div *ngIf="isDataLoaded == true && isDataAvailable == false && !restrictToday">
    <app-ltms-error [code]="errorCode"></app-ltms-error>
</div>